import { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Quill from 'quill';

const ModalAddListProductCategory = ({
    show,
    handleClose,
    dataParsing,
    sendData
}) => {

    const [loading, setLoading] = useState(null);

    const editorRef = useRef(null);
    const quillRef = useRef(null);
    const [editorValue, setEditorValue] = useState('');

    const [details, setDetails] = useState([]);

    const defaultData = {
        description: '',
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const cleanedValue = value.replace(/[^a-zA-Z0-9\s\/\\-]/g, '');
        e.target.value = cleanedValue;
        setDetails((prev) => ({
            ...value,
            [name]: cleanedValue,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const newDetails = {
            name: details?.name,
            description: editorValue,
            id_paket_detail: dataParsing?.row?.id_paket_detil,
            id_paket: dataParsing?.row?.id_paket,
            categoryProduct: dataParsing?.row?.id,

        };

        setDetails(newDetails);

        await sendData(newDetails);
        setLoading(false);
        setDetails({
            description: '',
        })
        handleClose()
    };

    useEffect(() => {
        const existingToolbars = document.querySelectorAll('.ql-toolbar');
        existingToolbars.forEach(toolbar => toolbar.remove());

        if (show && editorRef.current && !quillRef.current) {
            quillRef.current = new Quill(editorRef.current, {
                theme: 'snow',
                modules: {
                    toolbar: [
                        [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        ['bold', 'italic', 'underline'],
                        [{ 'align': [] }],
                        ['link'],
                        ['image'],
                    ],
                },
            });

            quillRef.current.root.innerHTML = defaultData.description;
            quillRef.current.on('text-change', () => {
                setEditorValue(quillRef.current.root.innerHTML);
            });
        }
        return () => {
            if (quillRef.current) quillRef.current = null; // Destroy Quill instance
        };
    }, [show]);

    return (
        <Modal
            size="xl"  // 'xl' size for larger modal
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
            dialogClassName="fullscreen-modal"  // Use dialogClassName for targeting modal styles if needed
            style={{
                maxWidth: '100%',
                height: '100vh', // Fullscreen height
                margin: 0, // Remove margin
                padding: 0, // Remove padding
            }}>
            <Modal.Header closeButton>
                <Modal.Title>List Product Category</Modal.Title>
            </Modal.Header>
            <Modal.Body className="grid-example">
                <Row>
                    <Col xs={12} md={12}>
                        <Form onSubmit={handleSubmit} className='mb-3'>
                            <Form.Group className="mb-2">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={details.name}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                            <Form.Label>Description</Form.Label>
                            <Form.Group className="mb-3">
                                <div ref={editorRef} style={{ height: '300px', border: '1px solid #ccc' }}></div>
                            </Form.Group>
                            <Button variant="primary" type="submit">
                                Add
                            </Button>
                        </Form>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default ModalAddListProductCategory;
